import { useRef, useState } from 'react';

// ════════════════════════════════════════════════════════════════════════
// Iter52.91 · B2 · Todas las descargas avisan de que están trabajando.
// Mismo patrón que el MAESTRO (52.85) pero en UN SOLO SITIO: al pulsar, ese
// botón se deshabilita, dice «Generando…» y no admite un segundo clic; al
// terminar o fallar vuelve a su estado. Un estado POR BOTÓN: descargar el ZIP
// no deja gris el CSV.
// ════════════════════════════════════════════════════════════════════════
export function crearControlDescargas(onCambio = () => {}) {
  const enCurso = new Set();
  return {
    activo: (id) => enCurso.has(id),
    async ejecutar(id, fn) {
      if (enCurso.has(id)) return undefined; // segundo clic: se ignora
      enCurso.add(id);
      onCambio(new Set(enCurso));
      try {
        return await fn();
      } finally {
        enCurso.delete(id);
        onCambio(new Set(enCurso));
      }
    },
  };
}

export function useDescargas() {
  const [activas, setActivas] = useState(() => new Set());
  const ctrl = useRef(null);
  if (!ctrl.current) ctrl.current = crearControlDescargas((s) => setActivas(s));
  return {
    descargando: (id) => activas.has(id),
    conEstadoDescarga: (id, fn) => ctrl.current.ejecutar(id, fn),
  };
}
